import {ThreeTsl as TSL} from "#material/three/exports"

export const threeWindowCoordinates = TSL.Fn(() => {
    // Transform to clip space
    const clipPosition = TSL.cameraProjectionMatrix.mul(TSL.modelViewMatrix).mul(TSL.vec4(TSL.positionLocal, 1.0))

    // Convert to NDC [-1,1]
    const ndc = clipPosition.xy.div(clipPosition.w)

    // Convert to [0,1] range (window space)
    return ndc.mul(0.5).add(0.5)
})
